// WebSocket utility functions

/**
 * Get the WebSocket URL based on environment
 */
export const getWebSocketUrl = (): string => {
  if (typeof window === "undefined") {
    // Server-side rendering
    return "";
  }

  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  const host = window.location.host;
  
  // In development, you might want to use a different port or host
  if (process.env.NODE_ENV === "development") {
    // Adjust this based on your backend WebSocket server
    return `${protocol}//${host}/websocket`;
  }
  
  // Production WebSocket URL
  return `${protocol}//${host}/websocket`;
};

/**
 * Check if WebSocket is supported
 */
export const isWebSocketSupported = (): boolean => {
  return typeof window !== "undefined" && "WebSocket" in window;
};

/**
 * Format timestamp for display
 */
export const formatTimestamp = (timestamp: number): string => {
  return new Date(timestamp).toLocaleTimeString();
};

/**
 * Generate a unique session ID
 */
export const generateSessionId = (clientId: number): string => {
  return `session-${clientId}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};


/**
 * Create a WebSocket message
 */
export const createWebSocketMessage = (action: string, data: any) => {
  return {
    action,
    data,
    timestamp: Date.now(),
  };
};

/**
 * Parse WebSocket error codes
 */
export const getWebSocketErrorMessage = (code: number): string => {
  switch (code) {
    case 1000:
      return "Normal closure";
    case 1001:
      return "Going away";
    case 1002:
      return "Protocol error";
    case 1003:
      return "Unsupported data";
    case 1005:
      return "No status received";
    case 1006:
      return "Abnormal closure";
    case 1007:
      return "Invalid frame payload data";
    case 1008:
      return "Policy violation";
    case 1009:
      return "Message too big";
    case 1010:
      return "Mandatory extension";
    case 1011:
      return "Internal server error";
    case 1015:
      return "TLS handshake";
    default:
      return `Unknown error code: ${code}`;
  }
};
